import PropTypes from 'prop-types';
import React from 'react';
import Dropzone from 'react-dropzone';

const SponsorshipSettings = ({
  entity,
  onEntityChange,
  onSave,
  onImmediateSave,
  onDebouncedSave,
  uploaded = false,
}) => {
  return (
    <div className="row">
      <div className="col-12">
        <p className="mb-1 text-dark"
           style={{"fontSize": "16px"}}>
          <strong>Ticketing Sponsorship</strong>
        </p>
        <div className="row">
          <div className="col-12 col-md-8">
            <p className="m-0 small text-muted">
              Add a sponsor that appears on all digital tickets. You can override this per event.
            </p>
          </div>
        </div>
        <div className="row" style={{"marginTop": "25px"}}>
          <div className="col-12 col-xl-4">
            <div className="custom-control custom-switch">
              <input
                id="show-sponsor-on-digital-tickets"
                type="checkbox"
                className="custom-control-input"
                checked={entity.show_sponsor_on_digital_tickets || false}
                onChange={e => {
                  var updated = Object.assign({}, entity, {
                    show_sponsor_on_digital_tickets: e.target.checked
                  });
                  onEntityChange(updated);
                  if (onImmediateSave) onImmediateSave(updated);
                }}
              />
              <label
                className="custom-control-label"
                style={{"fontSize": "14px"}}
                htmlFor="show-sponsor-on-digital-tickets"
              >
                Show sponsor on digital tickets
              </label>
            </div>
            {entity.show_sponsor_on_digital_tickets ? (
              <React.Fragment>
                <div className="mt-3">
                  <label
                    htmlFor="sponsor-name"
                    className="text-dark mb-1"
                  >
                    Sponsor name <span className="text-danger">*</span>
                  </label>
                  <input
                    id="sponsor-name"
                    type="text"
                    className="form-control"
                    style={{maxWidth: "400px"}}
                    value={entity.sponsor_name || ""}
                    onChange={e => {
                      var updated = Object.assign({}, entity, {
                        sponsor_name: e.target.value
                      });
                      onEntityChange(updated);
                      if (onDebouncedSave) onDebouncedSave(updated);
                    }}
                  />
                </div>
                <div className="mt-3">
                  {entity.sponsor_logo_url ? (
                    <div
                      className="d-flex align-items-center p-3 rounded"
                      style={{border: "1px solid var(--sl-border-secondary, #E9EAEB)", maxWidth: "400px"}}
                    >
                      <div
                        className="d-flex align-items-center mr-2"
                        style={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: "var(--sl-bg-active, #f4f9fc)",
                          borderRadius: "4px"
                        }}
                      >
                        <i
                          className="fas fa-file-image text-primary mx-auto"
                          style={{fontSize: "20px"}}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <p className="mb-0 small">
                          <strong>
                            {entity.sponsor_logo_file_name || "sponsor_logo.jpg"}
                          </strong>
                        </p>
                        <p className="mb-0 small text-muted">
                          {entity.sponsor_logo instanceof File && !uploaded ?
                            `${Math.round(entity.sponsor_logo_file_size / 1024)} KB – Click Save to upload` :
                            (entity.sponsor_logo_file_size ?
                              `${Math.round(entity.sponsor_logo_file_size / 1024)} KB` :
                              "Uploaded")}
                        </p>
                      </div>
                      <button
                        type="button"
                        className="btn btn-link text-muted p-0"
                        onClick={() => {
                          var updated = Object.assign({}, entity, {
                            destroy_sponsor_logo: true,
                            sponsor_logo_url: null,
                            sponsor_logo_file_name: null,
                            sponsor_logo_file_size: null
                          });
                          onEntityChange(updated);
                          if (onImmediateSave) onImmediateSave(updated);
                        }}
                      >
                        <i
                          className="far fa-trash-alt"
                          style={{fontSize: "18px"}}
                        />
                      </button>
                    </div>
                  ) : (
                    <Dropzone
                      maxFiles={1}
                      accept="image/svg+xml,image/png,image/jpeg"
                      onDrop={files => {
                        if (!files || files.length === 0) return;
                        const previewUrl = URL.createObjectURL(files[0]);
                        var updated = Object.assign({}, entity, {
                          sponsor_logo: files[0],
                          sponsor_logo_file_name: files[0].name,
                          sponsor_logo_file_size: files[0].size,
                          sponsor_logo_url: previewUrl
                        });
                        onEntityChange(updated);
                        if (onImmediateSave) onImmediateSave(updated);
                      }}
                    >
                      {({getRootProps, getInputProps}) => (
                        <section
                          className="d-flex flex-column justify-content-center align-items-center text-center"
                          style={{
                            height: "180px",
                            border: "2px dashed var(--sl-border-primary, #D5D7DA)",
                            borderRadius: "4px",
                            maxWidth: "400px",
                            padding: "20px"
                          }}
                        >
                          <div {...getRootProps()} style={{cursor: "pointer"}}>
                            <input {...getInputProps()} />
                            <i
                              className="fas fa-cloud-upload-alt mb-2"
                              style={{
                                color: "var(--sl-fg-quaternary, #717680)",
                                fontSize: "36px"
                              }}
                            />
                            <p className="mb-1">
                              <a
                                className="text-primary"
                                onClick={e => e.preventDefault()}
                                href="#"
                              >
                                Click to upload
                              </a> or drag and drop
                            </p>
                            <p className="mb-0 small text-muted">
                              SVG, PNG, or JPG (Max 1 MB. Square or horizontal; min 256 px height.)
                            </p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                  )}
                </div>
              </React.Fragment>
            ) : null}
            {onSave ? (
              <div className="mt-3">
                <button
                  type="button"
                  style={{"fontSize": "14px"}}
                  onClick={onSave}
                  className="team-btn-primary"
                >
                  <strong>Save</strong>
                </button>
              </div>
            ) : null}
          </div>
          {entity.show_sponsor_on_digital_tickets ? (
            <div className="col-12 col-xl-8 mt-3 mt-xl-0">
              <div
                className="mx-0 mx-xl-auto"
                style={{maxWidth: "568px"}}
              >
                <p className="mb-2">
                  <strong>
                    Preview
                  </strong>
                </p>
                <div className="d-flex flex-column flex-lg-row align-items-center align-items-lg-stretch justify-content-lg-start">
                  <div
                    className="d-flex align-items-center mb-3 mb-lg-0"
                    style={{
                      width: "360px",
                      minWidth: "360px",
                      backgroundColor: "#FAFAFA",
                      border: "1px solid #E9EAEB",
                      borderRadius: "8px",
                      padding: "12px",
                      marginRight: "22px"
                    }}
                  >
                    <div
                      className="flex-grow-1"
                      style={{
                        border: "1px solid #ececec",
                        borderRadius: "4px",
                        backgroundColor: "#fff"
                      }}
                    >
                      <div className="d-flex">
                        <div style={{padding: "12px", flex: "1"}}>
                          <p style={{color: "#686868", margin: "0px", fontSize: "10px"}}>
                            TICKET 1
                          </p>
                          <p style={{color: "#333333", margin: "0px", fontSize: "16px"}}>
                            <strong>Event Name</strong>
                          </p>
                          <p style={{color: "#686868", margin: "0px", fontSize: "11px"}}>
                            with Supporting Artist
                          </p>
                          <p style={{color: "#333333", margin: "12px 0px 0px 0px", fontSize: "11px"}}>
                            Ticket Name - $0.00
                          </p>
                          <p style={{color: "#686868", margin: "0px", fontSize: "11px"}}>
                            Event date and time
                          </p>
                          <p style={{color: "#686868", margin: "10px 0px 0px 0px", fontSize: "10px"}}>
                            6259 N. College Ave, Indianapolis IN 46220
                          </p>
                        </div>
                        <div style={{padding: "12px", textAlign: "right"}}>
                          <img
                            src="/opendate_qr_code.png"
                            style={{width: "60px", height: "60px"}}
                          />
                          {entity.sponsor_name || entity.sponsor_logo_url ? (
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{marginTop: "20px"}}
                            >
                              {entity.sponsor_logo_url ? (
                                <img
                                  src={entity.sponsor_logo_url}
                                  alt={entity.sponsor_name || "Sponsor"}
                                  style={{maxWidth: "100px", maxHeight: "30px", objectFit: "contain"}}
                                />
                              ) : (
                                <p style={{margin: "0", fontSize: "8px", color: "#333"}}>
                                  <strong
                                    style={{
                                      display: "block",
                                      maxWidth: "60px",
                                      wordWrap: "break-word",
                                      overflowWrap: "break-word",
                                      textAlign: "center"
                                    }}
                                  >
                                    {entity.sponsor_name}
                                  </strong>
                                </p>
                              )}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{
                    width: "170px",
                    border: "12px solid #000",
                    borderRadius: "8px",
                    backgroundColor: "#000",
                    position: "relative",
                    flexShrink: 0
                  }}>
                    <div style={{
                      padding: "0px 6px 6px 6px",
                      backgroundColor: "#fff",
                      position: "relative"
                    }}>
                      <div style={{
                        position: "absolute",
                        top: "-8px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "40px",
                        height: "20px",
                        backgroundColor: "#000",
                        borderBottomLeftRadius: "20px",
                        borderBottomRightRadius: "20px"
                      }}></div>
                      <div className="d-flex justify-content-between align-items-center pt-1 mb-1">
                        <img
                          src="/Alt@3x.png"
                          style={{height: "20px", marginLeft: "-2px"}}
                        />
                        <div style={{textAlign: "right", marginTop: "6px"}}>
                          <p style={{margin: "0", fontSize: "6px", color: "#999"}}>Date</p>
                          <p style={{margin: "0", fontSize: "5px"}}>Time</p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-start" style={{marginBottom: "4px"}}>
                        <div>
                          <p style={{margin: "0", fontSize: "6px", color: "#999"}}>EVENT</p>
                          <p style={{margin: "0 0 4px 0", fontSize: "8px", fontWeight: "bold"}}>Event Name</p>
                          <p style={{margin: "0", fontSize: "6px", color: "#999"}}>TICKET</p>
                          <p style={{margin: "0", fontSize: "5px"}}>Ticket type</p>
                        </div>
                        {entity.sponsor_logo_url ? (
                          <div style={{textAlign: "right", paddingTop: "14px"}}>
                            <img
                              src={entity.sponsor_logo_url}
                              alt={entity.sponsor_name || "Sponsor"}
                              style={{maxWidth: "60px", maxHeight: "20px", objectFit: "contain"}}
                            />
                          </div>
                        ) : entity.sponsor_name ? (
                          <div className="align-self-end" style={{textAlign: "right", paddingTop: "14px"}}>
                            <p style={{margin: "0", fontSize: "6px", color: "#999"}}>SPONSORED BY</p>
                            <p style={{margin: "0", fontSize: "5px"}}>{entity.sponsor_name}</p>
                          </div>
                        ) : null}
                      </div>
                      <div className="d-flex justify-content-between" style={{marginBottom: "2px"}}>
                        <div>
                          <p style={{margin: "0", fontSize: "6px", color: "#999"}}>LOCATION</p>
                        </div>
                        <div style={{textAlign: "right"}}>
                          <p style={{margin: "0", fontSize: "6px", color: "#999"}}>DOORS</p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between" style={{marginBottom: "4px"}}>
                        <div>
                          <p style={{margin: "0", fontSize: "5px"}}>The Vogue</p>
                        </div>
                        <div style={{textAlign: "right"}}>
                          <p style={{margin: "0", fontSize: "5px"}}>Time</p>
                        </div>
                      </div>
                      <p style={{margin: "0", fontSize: "5px", color: "#666"}}>6259 N College Ave<br/>Indianapolis, IN 46220</p>
                      <div className="text-center mt-3 mb-2">
                        <div style={{
                          width: "48px",
                          height: "48px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}>
                          <img
                            src="/opendate_qr_code.png"
                            style={{width: "48px", height: "48px"}}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

SponsorshipSettings.propTypes = {
  entity: PropTypes.object.isRequired,
  onEntityChange: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  onImmediateSave: PropTypes.func,
  onDebouncedSave: PropTypes.func,
  // The logo file has already been sent, though the entity still holds it.
  uploaded: PropTypes.bool,
};

export default SponsorshipSettings;
